// extracted by mini-css-extract-plugin
module.exports = {"discount":"_14910","content":"_13454","hd":"_13108","title":"_6980","arrow":"_6775","bd":"_5992"};